import React from "react"
import makeStyles from "@mui/styles/makeStyles"
import { connect } from "react-redux"
import DispatchTable from "./Product/DispatchTable"
import HubDispatchTable from "./Hub/HubDispatchTable"
import { updateDispatchTypeFilter } from "../../actions/Dispatch/dispatch"

const useClasses = makeStyles(() => ({
    container: {
        width: "100%"
    }
}))

const DispatchDone = (props) => {
    const {
        hubs=false,
        selectedTypeFilter,
        dispatchDataDone,
        updateDispatchTypeFilter,
        current,
        productTypeOptions
    } = props

    const classes = useClasses()
    const storage = JSON.parse(localStorage.getItem("searchValue"))
    const searchFilter = (storage && storage.dispatchToDo)?storage.dispatchToDo:""

    const _onProductTypeChange = (value) => {
        updateDispatchTypeFilter(value)
    }

    return (
        <div className={classes.container}>
            {
                !hubs &&
                <DispatchTable
                    canOpen={false}
                    tableType="done"
                    dispatchData={dispatchDataDone}
                    selectedType={selectedTypeFilter}
                    onProductTypeChange={_onProductTypeChange}
                    searchFilter={searchFilter}
                    storageIndex="dispatchDone"
                    productTypeOptions={productTypeOptions}
                />
            }
            {
                hubs &&
                <HubDispatchTable
                    canOpen={false}
                    tableType={current?"todo":"done"}
                    selectedType={selectedTypeFilter}
                    onProductTypeChange={_onProductTypeChange}
                    searchFilter={searchFilter}
                    storageIndex="dispatchDone"
                />
            }
        </div>
    )
}

export default connect((state) => {
    return {
        date: state.dispatch.date,
        dispatchDataDone: state.dispatch.dispatchDataDone,
        selectedTypeFilter: state.dispatch.selectedTypeFilter,
        productTypeOptions: state.dispatch.productTypeOptions
    }
}, {
    updateDispatchTypeFilter
})(DispatchDone)

